/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetSisenseSSOToken200Response } from '../models';
// @ts-ignore
import { PostSisenseUser201Response } from '../models';
// @ts-ignore
import { PostSisenseUserBody } from '../models';
/**
 * SisenseApi - axios parameter creator
 * @export
 */
export const SisenseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sisense SSO JWT Token取得API
         * @summary Sisense SSO JWT Token取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSisenseSSOToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/sso/sisense`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sisenseユーザー作成API
         * @summary Sisenseユーザー作成API
         * @param {number} clientId client ID
         * @param {PostSisenseUserBody} [postSisenseUserBody] Sisenseユーザー登録のparameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSisenseUser: async (clientId: number, postSisenseUserBody?: PostSisenseUserBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('postSisenseUser', 'clientId', clientId)
            const localVarPath = `/api/admin/clients/{clientId}/sisense/users`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSisenseUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SisenseApi - functional programming interface
 * @export
 */
export const SisenseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SisenseApiAxiosParamCreator(configuration)
    return {
        /**
         * Sisense SSO JWT Token取得API
         * @summary Sisense SSO JWT Token取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSisenseSSOToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSisenseSSOToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSisenseSSOToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sisenseユーザー作成API
         * @summary Sisenseユーザー作成API
         * @param {number} clientId client ID
         * @param {PostSisenseUserBody} [postSisenseUserBody] Sisenseユーザー登録のparameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSisenseUser(clientId: number, postSisenseUserBody?: PostSisenseUserBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSisenseUser201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSisenseUser(clientId, postSisenseUserBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SisenseApi - factory interface
 * @export
 */
export const SisenseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SisenseApiFp(configuration)
    return {
        /**
         * Sisense SSO JWT Token取得API
         * @summary Sisense SSO JWT Token取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSisenseSSOToken(options?: any): AxiosPromise<GetSisenseSSOToken200Response> {
            return localVarFp.getSisenseSSOToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Sisenseユーザー作成API
         * @summary Sisenseユーザー作成API
         * @param {number} clientId client ID
         * @param {PostSisenseUserBody} [postSisenseUserBody] Sisenseユーザー登録のparameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSisenseUser(clientId: number, postSisenseUserBody?: PostSisenseUserBody, options?: any): AxiosPromise<PostSisenseUser201Response> {
            return localVarFp.postSisenseUser(clientId, postSisenseUserBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SisenseApi - interface
 * @export
 * @interface SisenseApi
 */
export interface SisenseApiInterface {
    /**
     * Sisense SSO JWT Token取得API
     * @summary Sisense SSO JWT Token取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SisenseApiInterface
     */
    getSisenseSSOToken(options?: AxiosRequestConfig): AxiosPromise<GetSisenseSSOToken200Response>;

    /**
     * Sisenseユーザー作成API
     * @summary Sisenseユーザー作成API
     * @param {number} clientId client ID
     * @param {PostSisenseUserBody} [postSisenseUserBody] Sisenseユーザー登録のparameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SisenseApiInterface
     */
    postSisenseUser(clientId: number, postSisenseUserBody?: PostSisenseUserBody, options?: AxiosRequestConfig): AxiosPromise<PostSisenseUser201Response>;

}

/**
 * Request parameters for postSisenseUser operation in SisenseApi.
 * @export
 * @interface SisenseApiPostSisenseUserRequest
 */
export interface SisenseApiPostSisenseUserRequest {
    /**
     * client ID
     * @type {number}
     * @memberof SisenseApiPostSisenseUser
     */
    readonly clientId: number

    /**
     * Sisenseユーザー登録のparameters
     * @type {PostSisenseUserBody}
     * @memberof SisenseApiPostSisenseUser
     */
    readonly postSisenseUserBody?: PostSisenseUserBody
}

/**
 * SisenseApi - object-oriented interface
 * @export
 * @class SisenseApi
 * @extends {BaseAPI}
 */
export class SisenseApi extends BaseAPI implements SisenseApiInterface {
    /**
     * Sisense SSO JWT Token取得API
     * @summary Sisense SSO JWT Token取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SisenseApi
     */
    public getSisenseSSOToken(options?: AxiosRequestConfig) {
        return SisenseApiFp(this.configuration).getSisenseSSOToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sisenseユーザー作成API
     * @summary Sisenseユーザー作成API
     * @param {SisenseApiPostSisenseUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SisenseApi
     */
    public postSisenseUser(requestParameters: SisenseApiPostSisenseUserRequest, options?: AxiosRequestConfig) {
        return SisenseApiFp(this.configuration).postSisenseUser(requestParameters.clientId, requestParameters.postSisenseUserBody, options).then((request) => request(this.axios, this.basePath));
    }
}
